import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const dailyActiveUserGraphAction = createAsyncThunk(
    'daily-active-user-graph',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/dailyActiveUser`,data)

            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dailyActiveUserGraphSlice = createSlice({
    name: 'daily-active-user-graph',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dailyActiveUserGraphAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dailyActiveUserGraphAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(dailyActiveUserGraphAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const  dailyActiveUserGraphReducer = dailyActiveUserGraphSlice.reducer